<template>
  <div class="outer-wrapper">
    <div v-if="currentTask.name&&toggleShow==='operate'">
        <van-nav-bar
        title="任务备样确认"
        fixed
      >
      </van-nav-bar>
      <van-cell :value="currentTask.name" value-class="title-p"/>
      <van-cell :value="currentTask.standard" value-class="sub-title-p"/>
      <van-cell title="检测组" :value="currentTask.group_name" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="所需样品信息" :value="'共'+(currentTask.sampleList ? currentTask.sampleList.length : 0)+'件'" value-class="prop-value" title-class="prop-title"/>
      <div class="sample-list-wrapper">
          <div class="sample-list-inner-wrapper">
              <p v-if="currentTask.sampleList && currentTask.sampleList.length > 0" class="prop-value">
                <span v-for="(sample, index) in currentTask.sampleList" :key="index">
                  {{ (sample.name?sample.name:sample)+'；' }}
                </span>
              </p>
              <p v-else>
                <span>无</span>
              </p>
          </div>
      </div>
      <van-cell title="订单创建时间" :value="currentTask.order_time" value-class="prop-value" title-class="prop-title"/>
      <van-cell title="任务计划时间" :value="currentTask.plan_time" value-class="prop-value" title-class="prop-title"/>
      <!-- <van-cell title="任务完备时间" :value="currentTask.ready_time" value-class="prop-value" title-class="prop-title"/> -->
      <van-cell title="任务记录" is-link @click="taskRecordShow"/>
      <van-button type="primary" class="submit-b" block @click="confirm">确认</van-button>
    </div>
    <div v-else-if="currentTask.name&&toggleShow==='record'">
        <van-nav-bar
        :title="'任务操作记录('+(currentTask.name)+')'"
        left-text="返回"
        left-arrow
        @click-left="onClickBack"
        fixed
      ></van-nav-bar>
      <div v-if="recordList.length > 0">
        <van-cell-group
          :title="record.op_c==='plan'?'':record.op_time"
          v-for="(record, ri) in recordList"
          :key="ri"
          
        >
          <van-cell :value="record.op_text + (record.op_c==='plan'?('---'+record.op_time):'')+'；'" value-class="record-value" :icon="record.op_c==='plan'?'underway-o':''"/>
        </van-cell-group>
      </div>
      <div v-else>
          <van-empty description="暂无" />
      </div>
    </div>
    <div v-else-if="!currentTask.name">
        <van-empty description="该任务已失效（订单取消/流程更改...）" />
    </div>
    <div class="spin" v-else>
      <van-loading type="spinner" color="#1989fa" />
    </div>
  </div>
</template>
<script>
let userToken = localStorage.getItem("current_user_token");
import { textTrans } from "@/mixins/TextTrans.js";
//let authData = JSON.parse(localStorage.getItem("authData"));
import dayjs from 'dayjs';

export default {
  name: "taskAllot",
  components: {},
  mixins: [textTrans],
  props:{
    enid:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      toggleShow:'operate',
      currentTask:{},
      recordList:[]
    };
  },
  watch: {
  },
  computed: {
  },
  created() {
    this.getData();
  },
  methods: {
    getData() {
      this.$axios
        .post(this.$url + "/inspection_do", {
          userToken: userToken,
          ask_data: "taskInfo",
          enid:this.enid
        })
        .then(response => {
          if(response.data.stat==='ok'){
            this.currentTask = response.data.res_record;
            this.recordList = response.data.recordList;
            this.recordList.sort((a,b)=>dayjs(a.final_index)-dayjs(b.final_index));
          }else{
            this.$toast.fail('未找到数据！');
          }
        });
    },
    confirm(){
        this.$dialog.confirm({
        title: this.currentTask.group_name,
        message: '请确认将本任务所需的样品以及任务单等放入上述样品架',
        beforeClose:(action,done)=>{
            if(action==='confirm'){
                this.toggleShow = 'spin';
                this.$axios
                    .post(this.$url + "/inspection_do", {
                    userToken: userToken,
                    ask_data: "taskReady",
                    enid:this.enid
                    })
                    .then(response => {
                    if(response.data.stat==='ok'){
                        done();
                        this.$toast.success('操作成功！');
                        window.location.href = '/taskInfo/' + this.enid;
                    }else{
                        done();
                        this.$toast.fail('该操作已执行！');
                        window.location.href = '/taskInfo/' + this.enid;
                    }
                    });
            }else if(action==='cancel'){
                done();
            }else{
                done();
            }
        },
        }).catch(
            ()=>{
            }
        );
    },
    onClickBack(){
       this.toggleShow = 'operate';
    },
    taskRecordShow(){
        this.toggleShow = 'record';
    }
  }
};
</script>
<style scoped>
.title-p{
    font-weight: 700;
    font-size:0.9rem;
    text-align: center;
}
.sub-title-p{
    text-indent: 1.2rem;
    color:#999;
}

.prop-title{
    color:#999;
    font-size: 0.6rem;
}
.prop-value{
    color:#333;
    font-size: 0.7rem;
}
.spin{
  text-align: center;
  padding-top: 40%;
  
}

.sample-list-wrapper{
    text-align: center;
    width:100%;
    word-break:break-all;
}

.sample-list-inner-wrapper{
    margin:0.5rem 0.6rem;
}

.submit-b{
    position: fixed;
    bottom:0;
}

.record-value{
    text-indent: 1rem;
}

</style>